import React from "react";
import {Dictionary} from "../../components/Dictionary";
import {Util} from "../../components/Util";
import {DateTime} from "../../components/ListComponent/DateTime";

export class OrderScheduleData extends React.Component<any, any> {
    protected dictionary: Dictionary = new Dictionary();

    render() {
        return (
            <table className="table table-sm align-middle inlineTable">
                <tbody>
                <tr>
                    <td>{this.dictionary.get['service-provider']}</td>
                    <td>{this.props.item.service_name}</td>
                </tr>
                <tr>
                    <td>{this.dictionary.get['id']}</td>
                    {Util.copyCell(this.props.item.id || '')}
                </tr>
                <tr>
                    <td>{this.dictionary.get['type']}</td>
                    <td>{this.props.item.type}</td>
                </tr>
                <tr>
                    <td>{this.dictionary.get['status']}</td>
                    <td>{Util.status(this.isDateActive(this.props.item.schedule_start, this.props.item.schedule_end))}</td>
                </tr>
                <tr>
                    <td>{this.dictionary.get['schedule_start']}</td>
                    <td>{DateTime.create({value: this.props.item.schedule_start, inline: true})}</td>
                </tr>
                <tr>
                    <td>{this.dictionary.get['schedule_end']}</td>
                    <td>{DateTime.create({value: this.props.item.schedule_end, inline: true})}</td>
                </tr>
                </tbody>
            </table>
        );
    }

    isDateActive(startStr: string, endStr: string): string {
        const now = new Date();
        const startDate = new Date(startStr);
        const endDate = new Date(endStr);

        if (now < startDate) {
            return 'future';
        }
        if (endDate < now) {
            return 'expired';
        }
        return 'active';
    }
}
